import React from "react";
import { useQuery } from "@tanstack/react-query";

import useNotificationService from "../../services/api/notificationService";
import currencyFormatter from "../../util/currencyFormatter";

import { Badge } from "../Badge";
import { Chip } from "../Chip";
import { DotIcon, RetryIcon } from "../../assets/icons";
import styles from "./SmsGatewayStatus.module.scss";

function SmsGatewayStatus() {
  const { getSmsGateWayAccountStatus, queryKey } = useNotificationService();
  const { data: smsGatewayStatus, refetch } = useQuery({
    queryKey: [queryKey],
    queryFn: getSmsGateWayAccountStatus,
  });

  const handleRetry = () => {
    refetch();
  }

  return (
    <div className={styles.container}>
      <Badge icon={<RetryIcon />} className={styles.retryIcon} onClick={handleRetry} />

      <div className={styles.item}>
        <Badge text="Gateway" />
      </div>

      <Chip
        icon={<DotIcon className={styles.dot} />}
        className={styles.statusBadge}
        text={smsGatewayStatus?.data?.status === "active" ? "Active" : "Inactive"}
        variant={smsGatewayStatus?.data?.status === "active" ? "success" : "danger"}
      />

      <div className={styles.item}>
        <Badge text="Balance" />
      </div>

      <div className={styles.item}>
        <span className={styles.balanceValue}>
          {currencyFormatter(smsGatewayStatus?.data?.sms_credit_balance || 0)}
        </span>
      </div>
    </div>
  );
}

export default SmsGatewayStatus;
